import axios from 'axios';
const RESTAPI = import.meta.env.VITE_APP_RESTAPI || 'https://demo.routaapi.com/';

const state = () => ({
    isLoading: false,
    subscription: null,
    error: '',
    cancelRequest: null,
});

const actions = {
    async getSubscription({ commit, rootState, dispatch, state }) {
        // Don't fetch if already loaded
        if (state.subscription) {
            return state.subscription;
        }

        dispatch('cancelSubscription');

        commit('setError', '');
        commit('setLoading', true);

        const source = axios.CancelToken.source();
        commit('setCancelRequest', source.cancel);

        try {
            const response = await axios.get(RESTAPI + 'subscription', {
                cancelToken: source.token,
                headers: {
                    Authorization: rootState.token
                }
            });
            commit('setSubscription', response.data);
            return response.data;
        } catch (err) {
            if (axios.isCancel(err)) return;
            commit('setError', 'Could not get subscription');
        } finally {
            commit('setLoading', false);
            commit('setCancelRequest', null);
        }
    },
    cancelSubscription({ state }) {
        if (state.cancelRequest) {
            state.cancelRequest();
        }
    },
    resetSubscription({ commit, dispatch }) {
        dispatch('cancelSubscription');
        commit('clearSubscription');
    }
}

const mutations = {
    setSubscription(state, subscription) {
        state.subscription = subscription;
    },
    clearSubscription(state) {
        state.subscription = null;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    setError(state, error) {
        state.error = error;
    },
    setCancelRequest(state, func) {
        state.cancelRequest = func;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}